// extracted by mini-css-extract-plugin
export default {"modal":"wL-z","modalOverlay":"xL-z","outfitHeading":"yL-z"};